import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { Filter, Trigger, Channel, Bifurcation, Finish } from './_components';
import { momentumActions } from '../../../_actions';
import { Loader } from '../../../_components';
import { history, serialize, envConfig, userStatus, store } from '../../../_helpers';
import Tour from 'react-user-tour';
import moment from 'moment';
import DatePicker, { registerLocale } from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import Modal from 'react-bootstrap/Modal';
import formParser from './_functions/formParser';
import { companyNotFinishedRemovalReducer } from '../../../_reducers/Company.reducers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Diagram.momentum.scss';

registerLocale('pt-BR', ptBR);

const Components = {
  Filter,
  Trigger,
  Channel,
  Finish
}

class MomentumContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      domain_uuid: "",
      user_uuid: "",
      company_uuid: "",
      momentums: "",
      momentum_title: "",
      momentum_description: "",
      blocks: [],
      status: "Paused",
      schedule: null,
      scheduled_at: null,
      submitted: false,
      filterBlock: false,
      triggerBlock: false,
      channelBlock: false,
      bifurcationBlock: false,
      finishBlock: false,
      updating: false,
      saveType: 0,
      changedCustom: true,
      flowboardExpanded: false,
      showModal: false,
      stepTitle: "Passo 1",
      peopleCount: 0,
      peopleCountCalculated: false,
      peopleCountCalculating: false,
      viewMode: false,
      filterBlockCount: 0,
      blocksCount: 0,
      isTourActive: false,
      tourStep: 1,
      diagramPath: "/momentum/diagram",
      mainPath: "/momentums",
      isCampaign: false
    }

    this.form = React.createRef();
    this.momentumTitle = React.createRef();
    this.titleInput = React.createRef();
    this.flowboard = React.createRef();
    this.tourContainer = React.createRef();

    this.handleBlockAdd = this.handleBlockAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTitleInputSize = this.handleTitleInputSize.bind(this);
    this.handleSaveMethod = this.handleSaveMethod.bind(this);
    this.handleCustomize = this.handleCustomize.bind(this);
    this.handleFlowboardExpansion = this.handleFlowboardExpansion.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
    this.handleSchedule = this.handleSchedule.bind(this);
    this.handleWebview = this.handleWebview.bind(this);
    this.handlePercentageCalculation = this.handlePercentageCalculation.bind(this);
    this.handleFlowboardSize = this.handleFlowboardSize.bind(this);
    this.handleNoMoreTooltips = this.handleNoMoreTooltips.bind(this);
  }

  async componentDidMount() {
    document.title = `Momentum - Cellit.io`;

    if ( history.location.pathname === "/campaign/diagram" ) {
      document.title = `Campanha - Cellit.io`;
      this.setState({diagramPath: "/campaign/diagram", mainPath: "/campaigns", isCampaign: true});
    }

    const { dispatch } = this.props;
    const { selectedDomain } = await store.getState().changeDomainReducer;

    let domain = selectedDomain.domain_uuid;
    let userdata = JSON.parse(sessionStorage.getItem('cellit_userdata'));

    this.setState({
      domain_uuid: domain,
      company_uuid: userdata.company_uuid,
      user_uuid: userdata.user_uuid
    });

    if ( domain ) {
      dispatch(momentumActions.listFilters(domain))
        .then(data => {
          if (data) {
            if ( data.type === 'ALERT_FAILURE' ) {
              return toast.error(data.message.message, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'toast-error'
              });
            }
          }
        })
    }

    const uuid = queryString.parse(this.props.location.search).uuid;
    const mode = queryString.parse(this.props.location.search).mode;
    
    if (uuid) {
      dispatch(momentumActions.listMomentumById(uuid))
      .then(res => {
        const data = res.data.data;

        let blocks = data.momentums.map(item => {
          let type = item.type;

          type === 'dispatcher' ?  type = 'channel' : type = item.type;
          return {block: type.charAt(0).toUpperCase() + type.slice(1), cardData: item}
        });

        const convertedData = moment(data.scheduled_at).locale('en').utc().format('YYYY-MM-DDTHH:mm:ss');

        this.setState(prevState => ({
          momentum_title: data.momentum_title,
          blocks: [...this.state.blocks, ...blocks],
          filterBlock: blocks.length >= 1 ? true : false,
          triggerBlock: blocks.length >= 2 ? true : false,
          channelBlock: blocks.length >= 3 ? true : false,
          stepTitle: mode === 'view' ? 'Visualizar' : 'Editando',
          schedule: data.scheduled_at ? moment(convertedData)._d : null,
          scheduled_at: data.scheduled_at ? data.scheduled_at : null,
        }));
        
      });

      if (mode === 'view') return this.setState({viewMode: true});
    }

    if ( !localStorage.getItem('__cellitNoMoreTooltips') ) {
      this.setState({isTourActive: true});
    }
  }

  componentWillReceiveProps(e) {
    const st = store.getState().changeDomainReducer;
    const { domain_uuid } = this.state;
    if ( !st.selectedDomain || !st.selectedDomain.domain_uuid ) return;
    if ( domain_uuid === st.selectedDomain.domain_uuid ) return;

    this.setState({domain_uuid: st.selectedDomain.domain_uuid});
  }

  handleBlockAdd(e) {
    let type = e.target.getAttribute('data-block');
    let stepTitle = e.target.getAttribute('data-step-title');

    if ( type === "Filter" ) {
      let filterBlockCount = this.state.filterBlockCount++;
      this.setState({filterBlockCount, blocksCount: this.state.blocksCount + 1});
    }

    let params = {
      block: type
    }

    this.setState(prevState => ({
      blocks: [...prevState.blocks, params],
      stepTitle
    }));
    
    // Update block availability
    let typeLowercased = type.toLowerCase() + 'Block';
    this.setState({[typeLowercased]: true});    
  }

  handleBlockRemove = e => {
    let newCount = this.state.blocksCount;

    newCount--
    
    this.setState(prevState => ({
      blocksCount: newCount
    }));
  }

  handleChange(e) {
    e.preventDefault();

    if ( e.target.name === 'momentum-description' ) {
      return this.setState({momentum_description: e.target.value});
    }

    this.setState({momentum_title: e.target.value});
  }

  handleTitleInputSize(e) {
    e.target.style.width = ((e.target.value.length + 1) * 13) + 'px';

    this.setState({momentum_title: e.target.value});

    if ( e.target.value.length === 0 ) {
      let errMsg = '⚠ O título do Momentum não pode estar vazio.'
      if ( this.state.isCampaign ) errMsg = '⚠ O título da Campanha não pode estar vazio.'

      toast.warning(errMsg, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-warning'
      });
    }
  }

  handleSaveMethod(e) {
    this.setState({status: e.target.getAttribute('data-save-as')});
  }

  handleWebview(e) {
    this.setState({changedCustom: true});

    if (e === 'SUPERARE_WEBVIEW') 
      this.setState({changedCustom: false});
  }

  handleCustomize() {
    this.setState({changedCustom: true});
  }

  async handlePercentageCalculation() {
    await this.setState({peopleCountCalculating: true});

    let formData = serialize(this.form.current);
    let momentumObjects = await formParser(formData);

    if ( momentumObjects && momentumObjects.length === 0 ) return;

    let obj = {
      momentums: momentumObjects
    }

    const user = userStatus();
    let opt = {
      method: "POST",
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.bearer_token}`
      },
      body: JSON.stringify(obj)
    }

    let request = await fetch(`${envConfig.MOMENTUM_API_URL}/person/search/peopleImpacted/${this.state.domain_uuid}`, opt);
    if ( request.status !== 200 ) return Promise.reject(await request.json());

    let response = await request.json();

    await this.setState({
      peopleCountCalculating: false,
      peopleCountCalculated: true,
      peopleCount: response.data.percentualAtingido
    })
  }

  async handleSubmit(e) {
    e.preventDefault();

    const { dispatch } = this.props;

    let formData = serialize(e.target);

    let momentumObjects = await formParser(formData);

    let obj = {
      company_uuid: this.state.company_uuid,
      domain_uuid: this.state.domain_uuid,
      channel_uuid: sessionStorage.getItem('cell_selected_channel'),
      user_uuid: this.state.user_uuid,
      momentum_title: this.state.momentum_title,
      momentum_description: this.state.momentum_description,
      status: this.state.status,
      scheduled_at: this.state.scheduled_at,
      momentums: momentumObjects,
    }
    
    if ( this.state.isCampaign ) {
      obj.type = "campaign";
    }

    let self = this;

    const uuid = queryString.parse(this.props.location.search).uuid;

    if (uuid) {
      obj['uuid'] = uuid;

      dispatch(momentumActions.updateMomentum(obj))
        .then(res => {
          if ( res.type === 'STORE_MOMENTUM_FAILURE' ) {
            let errMsg = "O momentum não pode ser salvo sem um título.";
            if ( this.state.isCampaign ) errMsg = "A campanha não pode ser salvo sem um título."

            if ( !this.state.momentum_title || this.state.momentum_title.length === 0 ) res.error.message = errMsg; 

            return toast.warning(res.error.message, {
              position: toast.POSITION.TOP_RIGHT,
              className: 'toast-error'
            });
          }

          let sucMsg = "Seu momentum foi atualizado. Você será redirecionado em breve...";
          if ( this.state.isCampaign ) sucMsg = "Sua campanha foi atualizada. Você será redirecionado em breve...";
          sessionStorage.removeItem('cell_selected_channel');
          toast.success(sucMsg, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-success'
          });

          setTimeout(() => {
            history.push(`${this.state.mainPath}?domain=${self.state.domain_uuid}`)
          }, 2000);
        });
    } else {
      dispatch(momentumActions.storeMomentum(obj))
      .then(res => {
        if ( res.type === 'STORE_MOMENTUM_FAILURE' ) {
          let errMsg = "O momentum não pode ser salvo sem um título.";
          if ( this.state.isCampaign ) errMsg = "A campanha não pode ser salvo sem um título.";

          if ( !this.state.momentum_title || this.state.momentum_title.length === 0 ) res.error.message = errMsg;
          
          return toast.warning(res.error.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-error'
          });
        }

        let sucMsg = "Seu momentum foi criado. Você será redirecionado em breve...";
        if ( this.state.isCampaign ) sucMsg = "Sua campanha foi criada. Você será redirecionado em breve...";
        sessionStorage.removeItem('cell_selected_channel');
        toast.success(sucMsg, {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-success'
        });

        setTimeout(() => {
          history.push(`${this.state.mainPath}?domain=${self.state.domain_uuid}`)
        }, 2000);
      });
    }
  }

  handleFlowboardExpansion(e) {
    if ( !this.state.flowboardExpanded ) {
      document.querySelector('.sidebar').style.left = '-260px';
      return this.setState({flowboardExpanded: true});
    }

    document.querySelector('.sidebar').style.left = '0';
    this.setState({flowboardExpanded: false});
  }

  handleModalShow(e) {
    let show = false;

    if ( e && e.target.getAttribute('data-modal-show') ) {
      show = true;
    }

    this.setState({showModal: show});
  }

  handleSchedule(e) {
    this.setState({
      schedule: e,
      scheduled_at: moment(e).format('YYYY-MM-DDTHH:mm:ss.000') + 'Z'
    });
  }

  handleFlowboardSize(e) {
    this.flowboard.current.classList.toggle('open-description');
  }

  handleMobileSelect = value => {
    this.setState({mobileOption: value});
  }

  handleNoMoreTooltips = e => {
    this.setState({isTourActive: false});
    return localStorage.setItem('__cellitNoMoreTooltips', true);
  }

  render() {
    const { momentum_description } = this.state;
    
    return(
      <>
        {
          !this.state.updating && !this.state.isCampaign ?
            <Tour
              ref={this.tourContainer}
              active={this.state.isTourActive}
              step={this.state.tourStep}
              onNext={(step) => this.setState({tourStep: step})}
              onBack={(step) => this.setState({tourStep: step})}
              onCancel={() => this.setState({isTourActive: false})}
              backButtonText={"Voltar"}
              nextButtonText={"Próximo"}
              doneButtonText={"Finalizar"}
              closeButtonText={<i className="lnr lnr-cross"></i>}
              onCancel={this.handleNoMoreTooltips}
              arrowSize={10}
              steps={[
                {
                  step: 1,
                  selector: ".lnr-pencil",
                  title: <h2>Título do seu momentum</h2>,
                  body: <p>Aqui você pode adicionar o título que vai dar nome ao seu momentum. Lembre-se: O nome não pode ser repetido e nem estar vazio</p>,
                  position: 'bottom'
                },
                {
                  step: 2,
                  selector: ".btn-momentum-description",
                  title: <h2>Descrição do seu momentum</h2>,
                  body: <p>Esse é um campo opcional, mas você pode preenchê-lo para posteriormente identificar quais regras foram criadas nesse momentum.</p>,
                  position: 'bottom'
                },
                {
                  step: 3,
                  selector: ".block-add.filter-block",
                  title: <h2>Bloco de Filtro</h2>,
                  body: <p>Esse botão permite adicionar um bloco de filtro. Esse bloco lhe permite definir em sua regra, quais visitantes da sua página vão ser impactados de acordo com suas respectivas informações previamente coletadas e salvas em base.</p>,
                  position: 'bottom'
                },
                {
                  step: 4,
                  selector: ".block-add.trigger-block",
                  title: <h2>Bloco de Gatilho</h2>,
                  body: <p>Esse é um filtro complementar, porém necessário. Ele define, além do seu filtro primário, quais pessoas serão impactadas de acordo com o que realizaram na página. Por exemplo: Visita a uma página específica, recorrência de disparo, abandono de carrinho, eventos gerais...</p>,
                  position: 'bottom'
                },
                {
                  step: 5,
                  selector: ".block-add.channel-block",
                  title: <h2>Bloco de Canal</h2>,
                  body: <p>Esse é o coração do seu momentum. É ele quem vai definir por qual canal você impactará seu usuário. Por exemplo: Através de Notificações Push, Webview, SMS ou E-mail. Obs.: Pra antes de adicionar esse bloco, verifique na sua aba CANAIS, se já existe algum canal integrado ao seu domínio.</p>,
                  position: 'bottom'
                },
                {
                  step: 6,
                  selector: ".btn-group.dropup",
                  title: <h2>Agora é só testar e salvar!</h2>,
                  body: <p>Configurada todas as suas regras (não se esqueça de nenhum campo em branco), é só salvar o seu Momentum para disparo imediato ou até mesmo agendar um disparo para uma campanha específica.</p>,
                  position: 'topLeft'
                }
              ]}
            />
          : null
        }

        <section key={this.state.domain_uuid} className="component component-momentum">
          <div className="component-header"></div>

          {
            !this.state.updating ?
              <div className="component-body">
                <div className="momentum-diagram">

                  <div className="momentum-title">
                    <label htmlFor="momentum-title">
                      <i className="lnr lnr-pencil"></i>
                    </label>
                    <input
                      ref={this.titleInput}
                      id="momentum-title"
                      name="momentum-title"
                      type="text"
                      className="momentum-title"
                      value={this.state.momentum_title}
                      onChange={this.handleTitleInputSize}
                      readOnly={this.state.viewMode}
                    />
                    {!this.state.viewMode ? <p className="tip" >Editando</p> : null}
                  </div>

                  <div className="momentum-description">
                    <textarea name="momentum-description" id="momentum-description" cols="30" rows="10" placeholder="Defina a descrição para seu momentum..." onFocus={this.handleFlowboardSize} onBlur={this.handleFlowboardSize} onChange={this.handleChange} readOnly={this.state.viewMode}></textarea>
                    <label htmlFor="momentum-description">
                      <button type="button" className="btn-momentum-description">Editar descrição</button>
                      {
                        momentum_description.length !== 0 ?
                          <i className="description-snippet"><strong>Resumo: </strong>{momentum_description.length >= 100 ? momentum_description.substr(0, 100) + '...' : momentum_description}</i>
                        : null
                      }
                    </label>
                    {!this.state.viewMode ? <span>Editando</span> : null}
                  </div>

                  <div id="flowboard" ref={this.flowboard} className={`flowboard ${this.state.flowboardExpanded ? 'flowboard-expanded' : ''}`}>
                    <a href="javascript:void(0)" onClick={this.handleFlowboardExpansion} className="flowboard-expander" title="Expandir">
                      {
                        !this.state.flowboardExpanded ?
                          <i className="linearicons-expand2"></i>
                        : <i className="linearicons-contract2"></i>
                      }
                      
                    </a>

                    <div className="available-blocks">
                      <p className="title">{!this.state.isCampaign ? this.state.stepTitle : "Monte sua campanha"}</p>

                      {/* Filter Block */}
                      <div
                        className={this.state.filterBlock === false ? 'block-wrapper' : 'block-wrapper disabled'}
                        title={this.state.filterBlock === false ? 'Add Filter Block' : 'Filter block already added'}
                      >
                        <p className="title">Filtro</p>
                        <div className="block-add filter-block" data-block="Filter" onClick={this.handleBlockAdd} data-step-title="Passo 2">
                          <p>
                            <i className="linearicons-funnel"></i> Filtro
                          </p>
                        </div>
                      </div>

                      {/* Trigger Block */}
                      {
                        !this.state.isCampaign ?
                          <div
                            className={this.state.filterBlock === true && this.state.triggerBlock === false ? 'block-wrapper' : 'block-wrapper disabled'}
                            title={this.state.triggerBlock === false ? 'Add Trigger Block' : 'Trigger block already added'}
                          >
                            <p className="title">Gatilho</p>
                            <div className="block-add trigger-block" data-block="Trigger" onClick={this.handleBlockAdd} data-step-title="Passo 3">
                              <p><i className="linearicons-list3"></i> Gatilho</p>
                            </div>
                          </div>
                        : null
                      }

                      {/* Channel Block */}
                      {
                        !this.state.isCampaign ?
                          <div
                            className={this.state.triggerBlock === true && this.state.channelBlock === false ? 'block-wrapper' : 'block-wrapper disabled'}
                            title={this.state.channelBlock === false ? 'Add Channel Block' : 'Channel block already added'}
                          >
                            <p className="title">Canal</p>
                            <div className="block-add channel-block" data-block="Channel" onClick={this.handleBlockAdd} data-step-title="Passo 4">
                              <p><i className="linearicons-bubble-dots"></i> Canal</p>
                            </div>
                          </div>
                        : <div
                            className={this.state.channelBlock === false ? 'block-wrapper' : 'block-wrapper disabled'}
                            title={this.state.channelBlock === false ? 'Add Channel Block' : 'Channel block already added'}
                          >
                            <p className="title">Canal</p>
                            <div className="block-add channel-block" data-block="Channel" onClick={this.handleBlockAdd} data-step-title="Passo 4">
                              <p><i className="linearicons-bubble-dots"></i> Canal</p>
                            </div>
                          </div>
                      }

                      {
                        !this.state.isCampaign ?
                          <div
                            className={this.state.channelBlock === true && this.state.finishBlock === false ? 'block-wrapper' : 'block-wrapper disabled'}
                            title={this.state.finishBlock === false ? 'Adicionar bloco de fim' : 'Bloco de fim já adicionado.'}
                          >
                            <p className="title">Final</p>
                            <div className="block-add finish-block" data-block="Finish" onClick={this.handleBlockAdd} data-step-title="Todos os blocos foram adicionados">
                              <p><i className="linearicons-alarm-check"></i> Final</p>
                            </div>
                          </div>
                        : null
                      }

                      {
                        this.state.filterBlock ?
                          !this.state.peopleCountCalculating ?
                            this.state.peopleCountCalculated ?
                              <>
                                <p className="people-count">
                                  Impacto: <strong>{this.state.peopleCount}% da base</strong>
                                  <a href="#" onClick={this.handlePercentageCalculation} title="Recalcular">
                                    <i className="linearicons-refresh"></i>
                                  </a>
                                </p>
                              </>
                            : <a href="#" className="btn-calculate-users" onClick={this.handlePercentageCalculation}><strong>Calcular impacto</strong></a>
                          : <Loader className="mini-loading" />
                        : null
                      }
                    </div>

                    <div className="blocks-wrapper">
                      <form method="POST" id="diagram-form" onSubmit={this.handleSubmit} ref={this.form}>
                        {
                          this.state.blocks ?
                            this.state.blocks.map((item, index) => {
                              let Component = Components[item.block];
                              return <Component 
                                key={index} 
                                index={index} 
                                domain={this.state.domain_uuid} 
                                cardData={item.cardData} 
                                handleCustomize={this.handleCustomize} 
                                handleWebview={this.handleWebview}
                                viewMode={this.state.viewMode}
                                handleMobileSelect={this.handleMobileSelect}
                                mobileOption={this.state.mobileOption}
                                handleBlockAdd={this.handleBlockAdd}
                                handleBlockRemove={this.handleBlockRemove}
                                multipleFilters={this.state.blocksCount}
                                filterBlockCount={item.block === "Filter" ? this.state.filterBlockCount : null}
                              />;
                            }
                          ) : "Algo deu errado. Tente novamente mais tarde."
                        }

                        <div className="buttons-group">
                          <Link to={`${this.state.mainPath}?domain=${this.state.domain_uuid}`} className="btn btn-red custom-return-btn">
                            <i className="linearicons-arrow-left"></i>
                            Voltar
                          </Link>

                          {
                            this.state.viewMode ? 
                              <Link to={`${this.state.mainPath}?domain=${this.state.domain_uuid}`} className="btn btn-blue">
                                OK
                              </Link>
                            : <div className="btn-group dropup">
                                <button type="button" className={`btn btn-blue dropdown-toggle`} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  Salvar como:
                                </button>
                                <div className="dropdown-menu">
                                  <button type="submit" onClick={this.handleSaveMethod} data-save-as="Draft"><i className="linearicons-pencil4"></i> Rascunho</button>
                                  <button type="button" onClick={this.handleModalShow} data-modal-show="true" data-save-as="Paused"><i className="linearicons-alarm-add2"></i> Agendamento</button>
                                  <button type="submit" onClick={this.handleSaveMethod} data-save-as="Active"><i className="linearicons-play-circle"></i> Imediato</button>
                                </div>
                              </div>
                          }
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            : <div className="component-body"><Loader /></div>
          }
        </section>

        <Modal
          className="custom-card-modal"
          size="sm"
          centered
          show={this.state.showModal}
          onHide={this.handleModalShow}
        >
          <Modal.Body>
            <p className="custom-modal-title">Agendar {!this.state.isCampaign ? "momentum" : "campanha"}</p>
            <DatePicker
              className="form-control"
              locale="pt-BR"
              selected={this.state.schedule}
              onChange={this.handleSchedule}
              value={this.state.schedule}
              timeInputLabel="Horário"
              dateFormat="dd/MM/yyyy HH:mm"
              placeholderText="Defina o dia e hora"
              showTimeInput
            />

            <button type="button" className="btn btn-red btn-small" onClick={this.handleModalShow}>Cancelar</button>
            <button type="submit" form="diagram-form" className="btn btn-blue btn-small float-right" onClick={this.handleSaveMethod} data-save-as="Paused" data-save-type="schedule">Agendar</button>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

function mapStateToProps(state) {
  const { createdMomentum } = state.createMomentumReducer;
  return createdMomentum;
}

const ConnectedMomentumContainer = connect(mapStateToProps)(MomentumContainer);
export { ConnectedMomentumContainer as MomentumContainer }